import { render, staticRenderFns } from "./SubmissionDetails.vue?vue&type=template&id=fda8d424&scoped=true&"
import script from "./SubmissionDetails.vue?vue&type=script&lang=js&"
export * from "./SubmissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionDetails.vue?vue&type=style&index=0&id=fda8d424&prod&lang=scss&scoped=true&"
import style1 from "./SubmissionDetails.vue?vue&type=style&index=1&id=fda8d424&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda8d424",
  null
  
)

export default component.exports